import { GraphSelectionModel } from "@features/graph/graphViewModel"
import { graphSelectionChangeHandler } from "@features/graph/handlers/graphSelectionChangeHandler"
import {
  graphApplyEdgeChanges,
  graphApplyNodeChanges,
} from "@features/graph/changes/graphApplyChanges"
import { GraphStoreType } from "@features/graph/Graph"

export const graphNodeClickHandler = (id: string, graphStore: GraphStoreType) => {
  const { nodeInternals, edges, defaultEdgeOptions } = graphStore.getState()
  const currentSelection = GraphSelectionModel.selected
  const { nodeChanges } = GraphSelectionModel.clearSelectionChanges()
  GraphSelectionModel.clear()
  const selection = { id, selected: true }
  if (currentSelection === id) {
    selection.selected = false
    GraphSelectionModel.selected = undefined
  } else {
    GraphSelectionModel.selected = id
  }
  const nodes = graphSelectionChangeHandler(selection, nodeInternals, edges)
  nodes.forEach((n) => {
    if (nodeChanges[n.id]) {
      // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
      if (!nodeChanges[n.id].selected) {
        nodeChanges[n.id] = n
      }
    } else {
      nodeChanges[n.id] = n
    }
  })

  graphStore.setState({
    nodeInternals: graphApplyNodeChanges(nodeChanges, nodeInternals),
    edges: graphApplyEdgeChanges(edges, defaultEdgeOptions),
  })
}
